import Box from "@material-ui/core/esm/Box";
import Toolbar from "@material-ui/core/esm/Toolbar";
import IconButton from "@material-ui/core/esm/IconButton";
import SwipeableDrawer from "@material-ui/core/esm/SwipeableDrawer";
import Close from "@material-ui/icons/esm/Close";
import Menu from "@material-ui/icons/esm/Menu";
import React, { useState } from 'react';
import { useRouteMatch } from 'react-router-dom';
import Divider from 'components/Divider/Divider';
import Icon from 'components/Icons';
import { BoldSubtitle } from 'components/Text';
import FlytLogo from 'components/FlytLogo';
import useCurrentCustomer from 'hooks/customer/useCurrentCustomer';
import { CUSTOMERS, CREATE_CUSTOMER } from 'routes/customers/paths';
import useStyles from '../NavigationStyles';
import NavigationProfileMenu from '../ProfileMenu/NavigationProfileMenu';
import NavigationDrawerList from './NavigationDrawerList';
export default function NavigationDrawer() {
  const onCustomersPage = useRouteMatch(CUSTOMERS)?.isExact;
  const onCreateCustomerPage = useRouteMatch(CREATE_CUSTOMER)?.isExact;
  const {
    closeDrawerIcon,
    navigationProfileBox,
    drawerDivider,
    nameTitle,
    logo,
    customersBanner
  } = useStyles();
  const [isOpen, setIsOpen] = useState(false);
  const {
    customer
  } = useCurrentCustomer();
  const name = customer?.organizationName ?? `${customer?.personFirstName || ''} ${customer?.personLastName || ''}`;
  const toggleDrawer = () => setIsOpen(!isOpen);
  if (onCustomersPage || onCreateCustomerPage) {
    return /*#__PURE__*/React.createElement(Toolbar, null, /*#__PURE__*/React.createElement("div", {
      className: customersBanner
    }, /*#__PURE__*/React.createElement("div", {
      className: logo
    }, /*#__PURE__*/React.createElement(FlytLogo, null)), /*#__PURE__*/React.createElement(NavigationProfileMenu, null)));
  }
  const iOS = typeof window !== 'undefined' &&
  // check if in browser
  /iPad|iPhone|iPod/.test(navigator.userAgent);
  return /*#__PURE__*/React.createElement(Toolbar, null, /*#__PURE__*/React.createElement(IconButton, {
    edge: "start",
    color: "inherit",
    "aria-label": "menu",
    onClick: toggleDrawer
  }, /*#__PURE__*/React.createElement(Menu, null)), /*#__PURE__*/React.createElement(SwipeableDrawer, {
    anchor: "left",
    open: isOpen,
    onClose: toggleDrawer,
    onOpen: toggleDrawer,
    disableBackdropTransition: !iOS,
    disableDiscovery: iOS
  }, /*#__PURE__*/React.createElement(Box, {
    className: closeDrawerIcon
  }, /*#__PURE__*/React.createElement(IconButton, {
    edge: "start",
    color: "inherit",
    "aria-label": "menu",
    onClick: toggleDrawer
  }, /*#__PURE__*/React.createElement(Close, null))), /*#__PURE__*/React.createElement(Divider, {
    className: drawerDivider,
    hasDefaultSpacing: false
  }), /*#__PURE__*/React.createElement(NavigationDrawerList, null)), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Icon, {
    name: "LOGO_SYMBOL"
  }), ' '), /*#__PURE__*/React.createElement(Box, {
    className: navigationProfileBox
  }, /*#__PURE__*/React.createElement(BoldSubtitle, {
    className: nameTitle,
    align: "right"
  }, name || ''), /*#__PURE__*/React.createElement(NavigationProfileMenu, null)));
}